<template>
  <div>
    <!-- 用于展示被删除的数据 -->
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 查询 -->
    <div class="examin_head">
      <el-form
        :label-position="labelPosition"
        label-width="90px"
        :model="formLabelAlign"
        ref="formLabelAlign"
      >
        <el-form-item label="上传时间：" prop="region">
          <el-date-picker
            v-model="viewTime"
            @change="searchChang"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="视频名称：" prop="name">
          <el-input
            v-model.trim="formLabelAlign.name"
            placeholder="请输入视频名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传者：" prop="account">
          <el-input
            v-model.trim="formLabelAlign.account"
            placeholder="请输入上传者"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频状态：" prop="videoState">
          <el-select
            v-model="formLabelAlign.videoState"
            placeholder="请选择"
            @change="searchChang"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option
              v-for="item in videoStateArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="query_btn" @click="searchList">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="searchData"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <!-- 表格 -->
    <div class="examinee_form" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage3 - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="220">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                @click.stop="handleClick(scope.row)"
                >查看</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="exportItem(scope.row)"
                >导出</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <p>
            共有{{ total }}条记录，当前第{{ pageIndex + 1 }}/{{ pagesun }}页
          </p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="eachPageNum"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import resourcereq from "@/api/resources";
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        name: "", //视频名称
        account: "", //上传者
        examBeginDate: "", //时间
        examEndDate: "", // 结束时间
        videoState: "0", // 视频状态 0:全部 1:开放中 2:未开放 3:已删除
      },
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100, //总条数
      pageIndex: 1,
      eachPageNum: 10, //当前也多少条数。
      formColumns: [
        {
          prop: "VideoName",
          label: "视频名称",
          // width: "90px",
        },
        {
          prop: "opennessTime",
          label: "视频开放时间",
          // width: "90px",
        },
        {
          prop: "CreateTime",
          label: "上传时间",
          // width: "90px",
        },
        {
          prop: "videoState",
          label: "视频状态",
          // width: "90px",
        },
        {
          prop: "RealName",
          label: "上传者",
          width: "80px",
        },
      ],
      viewTime: "", // 查询时间
      currentPage3: 1, //  当前页数
      // pageSize: 10,
      // total: 100,
      showpageindex: 1, //显示的索引盒子
      // pagesizesarr: [5, 10, 20, 50, 100],
      loading: true,
      getDataCondition: {
        name: "", //视频名称
        account: "", //上传者
      },
      videoStateArr: [
        {
          label: "已开放",
          value: "1",
        },
        {
          label: "未开放",
          value: "2",
        },
        {
          label: "已删除",
          value: "3",
        },
      ],
      getData: [],
    };
  },
  methods: {
    back() {
      if (this.$route.query.trainId) {
        // 培训过来的
        this.$router.push({
          path: this.$route.query.toUrl,
          query: {
            trainId: this.$route.query.trainId,
            toUrl: this.$route.query.toUrl,
            state:'xxqk'
          },
        });
      }else{
        this.$parent.cutcoms(0);
      }
      this.$destroy();
    },
    // 查询
    searchList() {
      this.currentPage3 = 1;
      this.getlist();
    },
    // chang搜索
    searchChang() {
      this.loading = true;
      if (this.viewTime == null) {
        this.formLabelAlign.examBeginDate = "";
        this.formLabelAlign.examEndDate = "";
      }
      this.getlist();
    },
    resetForm(formLabelAlign) {
      // 重置
      this.$refs[formLabelAlign].resetFields();
      this.getDataCondition.name = "";
      this.getDataCondition.account = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.examEndDate = "";
      this.formLabelAlign.videoState = "0";
      this.viewTime = "";
      this.loading = true;
      this.currentPage3 = 1;
      this.showpageindex = 1;
      this.getlist();
    },
    // 搜索
    searchData() {
      this.loading = true;
      this.formLabelAlign.pageIndex = 0;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      if (this.formLabelAlign.account) {
        this.getDataCondition.account = this.formLabelAlign.account;
      } else {
        this.getDataCondition.account = "";
      }
      this.getlist();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getlist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.loading = true;
      this.getlist();
    },
    async getlist() {
      if (this.viewTime) {
        const time = JSON.parse(JSON.stringify(this.viewTime));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      //获取列表信息
      let params = {
        VideoName: this.getDataCondition.name, // 视频名称查询
        videoStatus: this.formLabelAlign.videoState, // 视频状态
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        url: "/api/courseware/VideoManage/getVideoList",
        UserID: JSON.parse(localStorage.getItem("userlist")).userID,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        pageIndex: this.pageIndex - 1,
        pageCount: this.eachPageNum,
        userName: this.getDataCondition.account, //查询上传者
        keyStr: ".show.bottom",
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        createStartTime: this.formLabelAlign.examBeginDate || "", // 起始时间
        createEndTime: this.formLabelAlign.examEndDate || "", // 终止时间
        _examID: "",
      };
      const { data } = await systemclass.getAllVideo(params);
      if (data.Status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.total = data.Data.result[1][0].count;
        this.pagesun = data.Data.pageCount;
        const timestamp = new Date().getTime();
        this.getData = data.Data.result[0].map((item) => {
          item.opennessTime =
            this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
            "-" +
            this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
          item.CreateTime = this.$moment(item.CreateTime).format(
            "YYYY/MM/DD HH:mm"
          );
          if (item.Enable == 0) {
            item.videoState = "已删除";
          } else if (
            timestamp > new Date(item.BeginTime).getTime() &&
            timestamp < new Date(item.EndTime).getTime()
          ) {
            item.videoState = "已开放";
          } else {
            item.videoState = "未开放";
          }
          return item;
        });
      } else {
        this.$message.error(data.Msg);
      }
      console.log(data, "ssss");
    },
    // 查看
    handleClick(row) {
      this.$parent.videoid = row.VideoID;
      this.$parent.title = row.VideoName
      this.$parent.newState = 1;
      this.$parent.cutcoms(2);
    },
   async init(){
       if(this.$route.query.trainId){
        const obj = {
          scoreId: this.$route.query.scoreId,
          type: this.$route.query.type,
          typeId: this.$route.query.typeId,
        };
        const { data } = await training.getTypeDetail(obj);
        if (data.Status == 200) {
          this.handleClick(data.Data.videoInfo)
        }else {
          this.$message.error(data.Data);
        }
       }
    },
    // 导出
    async exportItem(row) {
      console.log(row);
      let pamars = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        videoID: row.VideoID,
      };
      let res;
      //   if (this.$parent.courseware == "courseware") {
      //     pamars["courseID"] = row.VideoID;
      //     res = await resourcereq.courseImportExcel(pamars);
      //   } else {
      res = await resourcereq.videoImportExcel(pamars);
      console.log(res);
      if (res.status == 200) {
        const blob = new Blob([res.data]);
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `导出${row.VideoName}学习进度.xlsx`);
        link.click();
        this.$message({
          message: "正在导出，请稍后",
          type: "success",
        });
        link = null;
      } else {
        this.$message.error(res.data || res.statusText);
      }
      return;
      //   }
    },
  },
  activated() {
    this.getlist();
    this.init()
  },
};
</script>

<style lang="scss" scoped>
.examinee_form {
    min-height: 480px;
    // height: 100%;
    background: #fff;
    // padding: 0px 20px 0px 34px;
    padding: 24px;
  }
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.examin_head {
  padding: 30px 24px 10px 30px;
  //  background-color: #64b5ff;
  display: flex;
  // justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid rgba(231, 231, 231, 0.774);
  .el-form {
    display: flex;
  }
  .query_btn {
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    //background-color: #333333;
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep.el-table th > .cell {
  text-align: center;
}
::v-deep .el-table-column--selection .cell {
  text-align: center;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(9) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-form {
  div:nth-child(2),
  div:nth-child(3) {
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
    }
  }
}
::v-deep .el-table .cell {
  text-align: center;
}
.operation_box {
  .el-button {
    font-size: 16px;
  }
}
</style>